import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12l-8 -8v16l16 -16v16l-4 -4","key":"svg-0"}],["path",{"d":"M20 12l-8 8l-4 -4","key":"svg-1"}]]

const IconBrandFramerMotion = createReactComponent('outline', 'brand-framer-motion', 'BrandFramerMotion', __iconNode);

export default IconBrandFramerMotion;